import {brickDefinitions} from "./brick-definitions";

const getBrickIcon = (brickType, brickConfig) => {
    brickConfig = brickConfig || {};
    return brickConfig.icon != null ? brickConfig.icon :  brickDefinitions[brickType].icon;
};

export default getBrickIcon;